import Tree from 'rc-tree'
import React, { useCallback, useEffect, useState } from 'react'
import LightTooltip from '../../../../commonComponents/LightTooltip'
import { Button, Checkbox, Dialog, DialogActions, DialogContent, Divider, FormControl, FormControlLabel, FormLabel, InputLabel, Menu, MenuItem, Radio, RadioGroup, Select, Stack, TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { customDecoding, filterNodes, filterOutNodeTypes, scrollToSelectedItem } from '../../../../utils/utilFunctions'
import { cloneDeep, debounce, isEmpty } from "lodash";
import { eachDeep } from "deepdash-es/standalone";
import SourceType from '../../../TemplateProperties/SourceType'
import { RECORD_TYPE } from '../../../../constants/datatypes'
import { MoreHorizOutlined } from "@mui/icons-material"
import RegularExpressionDialog from "../../Forms/RegularExpressionDialog"
import { operatorsDropdowns, SystemDataListArray, TRANSLATE_OUTBOUND_CONDITION_MAPPING_2, TRANSLATE_OUTBOUND_CONDITION_MAPPING_2_SOURCE } from '../../../../constants/constantList'
import { useDispatch, useSelector } from 'react-redux'
import { lgDocPath } from '../../../../constants/languageDocPaths'
import { api } from '../../../../redux/api'
import { inboundTemplateToRcTree } from '../../../../utils/rctreeDataConversion'
import WorkflowSourceType from '../../../../commonComponents/WorkflowSourceTypeComponent/WorkflowSourceType'

const OutboundConditionModal = ({ node, valuesHandler, ibTemplate, ibWorkflow, disabled }) => {
    const { t } = useTranslation()
    const [selectedKey, setSelectedKey] = React.useState([])
    const [expandedKeys, setExpandedKeys] = React.useState([])
    const [anchorEl, setAnchorEl] = React.useState(null)
    const conditionRef = React.useRef(null)
    const [treeData, setTreeData] = React.useState([])
    const [ibTree, setIbTree] = useState([]);
    const [isLoading, setIsLoading] = useState(false)
    const [open, setOpen] = React.useState(false)
    const [selectedNode, setSelectedNode] = React.useState({})
    const [openRegExDialog, setOpenRegExDialog] = useState(false);
    const { account, baseUrl, lang } = useSelector(state => state.queryParams);
    const [accountKeys, setAccountKeys] = useState([]);
    const [tradingpartnerKeys, setTradingPartnerKeys] = useState([]);
    const dispatch = useDispatch();
    const [isConfigured, setIsConfigured] = useState(false);
    const regExDocPath = `${baseUrl}/docs/${lgDocPath[lang] || 'en'}/Workbench/dialogs/regex.html`;

    const operatorDropdown = operatorsDropdowns.map((operator, index) => {
        return (<MenuItem key={index} value={operator.value}>{operator.text}</MenuItem>)
    })

    const mapping2RecordDropdown = TRANSLATE_OUTBOUND_CONDITION_MAPPING_2.map((operator, index) => {
        return (<MenuItem key={index} value={operator.value}>{operator.title}</MenuItem>)
    })

    const systemDataDropdown = Object.keys(SystemDataListArray).map((operator, index) => {
        return (<MenuItem key={index} value={operator}>{t(operator)}</MenuItem>)
    });

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        const getCleanedData = (data, operator) => {
            
            return data?.map(e => {
                let objSpread = {...e};
                Object.keys(objSpread).forEach(key => {
                    if (objSpread[key] === true) objSpread[key] = "TRUE";
                    if (objSpread[key] === false) objSpread[key] = "FALSE";
                })

                const newObj = {
                    ...objSpread,
                    ...((!objSpread?.hasOwnProperty("CHILDOPERATOR") && operator) ? { OPERATOR: operator } : {}),
                    ...(objSpread?.children?.length ? { CONDITION: getCleanedData(objSpread?.children, objSpread?.CHILDOPERATOR) } : {})
                }
                const keysRemoved = ["key", "title", "children", "ICON_DISPLAY"];

                keysRemoved.forEach(objSpread => {
                    if (newObj?.hasOwnProperty(objSpread)) delete newObj?.[objSpread];
                })
                return newObj; 
            })
        }
        const cleanedData = getCleanedData(treeData);
        valuesHandler(cleanedData);

        setOpen(false)
    }

    useEffect(() => {
        dataToRCTree(node?.CONDITION || [], true)
    }, [node?.key, open])


    const handleMenuClose = (source) => {
        setAnchorEl(null);
        if (source) {
            const data = JSON.parse(JSON.stringify(treeData));
            const newNode =
                source === "CONDITION" ? conditionNode : compoundConditionNode;
            if (!selectedKey?.length) {
                data.push(newNode);
                setSelectedKey(["cf-0"]);
                setSelectedNode({ key: "cf-0", ...newNode });
                if (source === "COMPOUND_CONDITION") setExpandedKeys(["cf-0"]);
            } else {
                const keyArray = selectedKey?.[0]?.split("-") || [];
                const [pre, ...rest] = keyArray;
                let tempData = data;
                for (let i = 0; i < rest.length; i++) {
                    const index = Number(rest[i]);
                    if (i === rest.length - 1) {
                        if (tempData?.[index]?.CHILDOPERATOR && source === "CONDITION") {
                            tempData = tempData?.[index]?.CONDITION;
                            tempData.push(newNode);
                            const key = selectedKey[0] + "-" + `${tempData?.length - 1}`;
                            setSelectedKey([key]);
                            setSelectedNode({ key, ...newNode });
                            setExpandedKeys((prev) => [...prev, selectedKey[0]]);
                        } else {
                            tempData.push(newNode);
                            keyArray.pop();
                            keyArray.push(tempData.length - 1);
                            setSelectedKey([keyArray?.join("-")]);
                            setSelectedNode({ key: keyArray?.join("-"), ...newNode });
                            if (source === "COMPOUND_CONDITION")
                                setExpandedKeys((prev) => [...prev, keyArray?.join("-")]);
                        }
                    } else {
                        tempData = tempData?.[index]?.CONDITION;
                    }
                }
            }
            dataToRCTree(data);
        }
    };

    const dataToRCTree = (data, initialRender) => {
        const clonedData = JSON.parse(JSON.stringify(data));
        const loopData = (data, parentKey) => {
            return data?.map((e, i) => {
                if (e.CONDITION) {
                    e.ICON_DISPLAY = "COMPOUND_CONDITION";
                } else {
                    e.ICON_DISPLAY = "MAPPING_CONDITION";
                }
                e["key"] = parentKey + "-" + i;
                if (e?.CONDITION && e?.CHILDOPERATOR)
                    e.title = e?.NAME + ` (${e.CHILDOPERATOR})`;
                else e.title = e?.NAME;
                if (e?.CONDITION?.length)
                    e.children = loopData(e?.CONDITION, parentKey + "-" + i);
                else e.children = [];
                return e;
            });
        };

        const newData = loopData(clonedData, "cf");
        setTreeData(newData);
        if (initialRender && newData?.length) {
            setSelectedKey([newData?.[0]?.key]);
            setSelectedNode(newData?.[0] || {});
        }
        if (initialRender && newData?.[0]?.children?.length) setExpandedKeys([newData?.[0]?.key]);
    };

    const conditionsUpdater = (key, value, valuesObj) => {
        const rcTreeData = cloneDeep(treeData);
        eachDeep(rcTreeData, (obj) => {
            if (obj?.key && obj?.key === selectedNode?.key) {
                if (!key) {
                    Object.keys(valuesObj).forEach((e) => {
                        obj[e] = valuesObj[e];
                    });
                } else obj[key] = value;
                setSelectedNode(obj);
            }
        });
        dataToRCTree(rcTreeData);
    };

    const conditionDeleteHandler = () => {
        const data = JSON.parse(JSON.stringify(treeData));
        const keyArray = selectedKey?.[0]?.split("-") || [];
        const [pre, ...rest] = keyArray;
        let tempData = data;
        let parentNode = {};
        for (let i = 0; i < rest.length; i++) {
            const index = Number(rest[i]);
            if (i === rest.length - 1) {
                let key = selectedKey?.[0]?.split("-");
                if (index === 0) {
                    if (key?.length === 2 && tempData?.length === 1) {
                        setSelectedKey([]);
                        setSelectedNode({});
                    }
                    if (key?.length === 2 && tempData?.length > 1) {
                        setSelectedKey(["cf-0"]);
                        setSelectedNode(tempData?.[1] || {});
                    } else {
                        if (key.length > 2) {
                            key.pop();
                            setSelectedKey([key.join("-")]);
                            setSelectedNode(parentNode);
                        } else {
                            setSelectedKey([]);
                            setSelectedNode({});
                        }
                    }
                } else {
                    key?.pop();
                    key?.push(index - 1);
                    setSelectedKey([key?.join("-")]);
                    setSelectedNode(tempData?.[index - 1] || {});
                }
                tempData.splice(index, 1);
            } else {
                parentNode = tempData?.[index];
                tempData = tempData?.[index]?.CONDITION;
            }
        }
        dataToRCTree(data);
    };

    // const conditionCopyHandler = () => {
    //     console.log("Copy")
    // }

    const titleRender = (node) => {
        return <span data-key={`${node?.key}`}>{node.title}</span>;
    }

    const Icon = (node) => {
        return (
            <span
                data-key={`${node?.key}`}
                className={"tree-icon " + node.ICON_DISPLAY}
            ></span>
        );
    };

    const switcherIcon = (obj) => {
        if (obj.isLeaf) return;
        if (obj.expanded) return <ArrowDropDownIcon />;
        else return <ArrowRightIcon sx={{ color: "#666666" }} />;
    };

    const selectHandler = (selectedKeys, info) => {
        setSelectedKey([info.node.key])
        setSelectedNode(info.node)
    }

    const expandHandler = (expandedKeys, { expanded, node }) => {
        setExpandedKeys(expandedKeys)
    }

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target
        conditionsUpdater(name, type === "checkbox" ? (checked ? "TRUE" : "FALSE") : value)
    }

    useEffect(() => {
        if (conditionRef?.current) {
            scrollToSelectedItem(selectedKey, conditionRef);
        }
    }, [selectedKey]);

    useEffect(() => {
        if (["ACCOUNT_KEYS", "TRADING_PARTNER_KEYS"].includes(selectedNode?.RECORD_TYPE2)) {
            const apiEndpoints = {
                'ACCOUNT_KEYS': api.endpoints.getAccountData,
                'TRADING_PARTNER_KEYS': api.endpoints.getTradingPartnersKeys
            }
            dispatch(apiEndpoints?.[selectedNode?.RECORD_TYPE2]?.initiate({
                account
            }, { forceRefetch: true }))
                .then(res => {
                    if (res.data.current_state === "SUCCESS") {
                        let data;

                        if (res?.data?.data?.account_data_keys) {
                            data = res?.data?.data?.account_data_keys.map(
                                (o) => Object?.keys(o)?.[0]
                            );
                        } else if (res?.data?.data?.trading_partner_keys) {
                            data = res?.data?.data?.trading_partner_keys;
                        }
                        if (data) {
                            const newData = [t("SELECT"), ...data];
                            const options = newData.map((opt, idx) => ({
                                key: `${opt}-${idx}`,
                                value: opt,
                                label: opt
                            }))
                            if (selectedNode?.RECORD_TYPE2 === "ACCOUNT_KEYS") setAccountKeys(options?.map(e => {
                                return <MenuItem value={e?.value}>{e?.value}</MenuItem>
                            }));
                            if (selectedNode?.RECORD_TYPE2 === "TRADING_PARTNER_KEYS") setTradingPartnerKeys(options?.map(e => {
                                return <MenuItem value={e?.value}>{e?.value}</MenuItem>
                            }));
                        }
                    }
                })
        }
    }, [selectedNode?.RECORD_TYPE2])


    useEffect(() => {
        if (!ibTemplate || !ibWorkflow) {
            setIbTree({});
            return;
        }
        const workflow = ibWorkflow;
        const template = ibTemplate;
        setIsLoading(true);
        dispatch(
            api.endpoints.getInboundTemplateData.initiate(
                {
                    workflowGroupName: workflow,
                    templateName: template,
                    account: account,
                },
                { forceRefetch: true }
            )
        ).then((res) => {
            if (res?.error) {
                setIbTree({})
                return;
            }
            const headerData = filterOutNodeTypes(
                filterNodes(inboundTemplateToRcTree(res.data, "HEADER"), "header"),
                []
            );
            const bodyData = filterOutNodeTypes(
                filterNodes(inboundTemplateToRcTree(res.data, "BODY"), "body"),
                []
            );
            const trailerData = filterOutNodeTypes(
                filterNodes(
                    inboundTemplateToRcTree(res.data, "TRAILER"),
                    "trailer"
                ),
                []
            );
            setIbTree((prev) => {
                return { header: headerData, body: bodyData, trailer: trailerData };
            });
        })
            .catch((error) => {
            })
            .finally(() => {
                setIsLoading(false)
            })


    }, [ibTemplate, ibWorkflow])


    useEffect(() => {
        if(treeData?.length) setIsConfigured(true);
        else setIsConfigured(false);
    }, [treeData?.length, selectedNode?.key])

    return (
        <>
            <Button 
                variant='outlined' 
                style={{width: "100%", marginTop: "10px"}} 
                onClick={() => {
                    if (disabled) return;
                    setOpen(true);
                }}
                disabled={disabled}
            >
                {isConfigured ? `${t("BTN_OUT_COND_PROPS")} (${t("SET")})` : t("BTN_OUT_COND_PROPS")}
            </Button>
            <Dialog sx={styles.dialog} maxWidth="sm" fullWidth open={open} onClose={() => setOpen(false)}>
                <div style={styles.dialogHeader} className="dialog-header">
                    <div className="title">{t("BTN_OUT_COND_PROPS")}: {node?.OUTBOUND_NAME || "UNNAMED"}</div>
                </div>
                <DialogContent className="dialog-content">
                    <div>
                        <div
                            style={{
                                marginBottom: "4px",
                                overflowX: "hidden",
                                position: "relative",
                            }}
                            ref={conditionRef}
                            className="div-textBox-conditional-field"
                        >
                            <div
                                style={{
                                    backgroundColor: "#F2F2F2",
                                    position: "sticky",
                                    top: "0",
                                    zIndex: "1000",
                                }}
                            >
                                <div
                                    style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        width: "93%",
                                        margin: "auto",
                                        padding: "2px",
                                    }}
                                >
                                    <div
                                        style={{
                                            color: "#666666",
                                            fontSize: "13px",
                                            fontWeight: "500",
                                        }}
                                    >
                                        {t("LBL_CONDITIONS")}
                                    </div>
                                    <div style={{ display: "flex", gap: "5px" }}>
                                        <div>
                                            <LightTooltip arrow onClick={handleMenuClick}>
                                                <span
                                                    style={{ cursor: "pointer" }}
                                                    className="ADD_MUI"
                                                ></span>
                                            </LightTooltip>
                                            <Menu
                                                anchorEl={anchorEl}
                                                open={Boolean(anchorEl)}
                                                onClose={() => handleMenuClose()}
                                                anchorOrigin={{
                                                    vertical: "bottom",
                                                    horizontal: "left",
                                                }}
                                            >
                                                <MenuItem onClick={() => handleMenuClose("CONDITION")}>
                                                    {t("MNU_NEW_COND")}
                                                </MenuItem>
                                                <MenuItem
                                                    onClick={() => handleMenuClose("COMPOUND_CONDITION")}
                                                >
                                                    {t("MNU_NEW_COMP_COND")}
                                                </MenuItem>
                                            </Menu>
                                        </div>
                                        <LightTooltip
                                            onClick={conditionDeleteHandler}
                                            title={t("DELETE")}
                                            arrow
                                        >
                                            <span
                                                style={{ cursor: "pointer" }}
                                                className="DELETE_MUI"
                                            ></span>
                                        </LightTooltip>
                                        {/* <LightTooltip
                                            onClick={conditionCopyHandler}
                                            title={t("MNU_COPY")}
                                            arrow
                                        >
                                            <span
                                                style={{ cursor: "pointer" }}
                                                className="FILE_COPY"
                                            ></span>
                                        </LightTooltip> */}
                                    </div>
                                </div>
                            </div>
                            <Tree
                                titleRender={titleRender}
                                treeData={treeData}
                                icon={Icon}
                                selectedKeys={selectedKey}
                                switcherIcon={switcherIcon}
                                onSelect={selectHandler}
                                expandedKeys={expandedKeys}
                                onExpand={expandHandler}
                            />
                        </div>
                    </div>

                    <Stack spacing={2} px={1} mt={2}>
                        <TextField disabled={!selectedNode?.hasOwnProperty("key")} fullWidth size="small" label={t("LBL_CONDITION_NAME")} name="NAME" value={selectedNode.NAME || ""} onChange={(e) => {
                            const name = e?.target?.value ? e?.target?.value : "UNNAMED";
                            conditionsUpdater("NAME", name);
                        }} />
                        {
                            selectedNode?.hasOwnProperty("CHILDOPERATOR") ?
                                <>
                                    <InputLabel>{t("LBL_SEL_OPER_FOR_COND_CONTAINED_WITHIN_COMP_COND")}</InputLabel>
                                    <FormControl
                                        sx={{
                                            display: "flex",
                                            flexDirection: "row",
                                            alignItems: "center",
                                        }}
                                        ml={3}
                                        disabled={!selectedNode?.hasOwnProperty("key")}
                                    >
                                        <FormLabel>{t("LBL_COMPOUND_OPER")}</FormLabel>
                                        <RadioGroup
                                            row
                                            name="CHILDOPERATOR"
                                            value={selectedNode?.CHILDOPERATOR || "AND"}
                                            onChange={(e) => {
                                                conditionsUpdater("CHILDOPERATOR", e.target.value);
                                            }}
                                        >
                                            <FormControlLabel
                                                value={"OR"}
                                                control={<Radio />}
                                                label={"OR"}
                                            />
                                            <FormControlLabel
                                                value={"AND"}
                                                control={<Radio />}
                                                label={"AND"}
                                            />
                                        </RadioGroup>
                                    </FormControl>
                                </> : <>
                                    <InputLabel>{t("LBL_DATA_MAPPING_")} 1</InputLabel>
                                    {open && <SourceType
                                        disabled={!selectedNode?.hasOwnProperty("key")}
                                        valuesHandler={(values) => {
                                            conditionsUpdater(null, null, {
                                                RECORD_TYPE: values?.RECORD_TYPE,
                                                MAPNAME: values?.MAPNAME,
                                                PARENT: values?.PARENT,
                                            })
                                        }}
                                        node={{
                                            RECORD_TYPE: selectedNode?.RECORD_TYPE,
                                            MAPNAME: selectedNode?.MAPNAME,
                                            key: selectedNode?.key,
                                            PARENT: selectedNode?.PARENT
                                        }}
                                        isCustomIbTemplate={true}
                                        treeData={ibTree}
                                        hideOutboundOption={true}
                                        allowAllTreeSelection={true}
                                    />}
                                    <Divider />
                                    <InputLabel>{t("LBL_OPERATOR")}</InputLabel>
                                    <div style={{ display: "flex" }}>
                                        {!["TRUE", "FALSE"].includes(selectedNode.COMPARE) ? <FormControlLabel disabled={!selectedNode?.hasOwnProperty("key")} control={<Checkbox name="COMPARE_ACTION_NOT" checked={selectedNode.COMPARE_ACTION_NOT === "TRUE"} onChange={handleChange} />} label={t("BTN_NOT")} /> : ""}
                                        <FormControl disabled={!selectedNode?.hasOwnProperty("key")} fullWidth size="small">
                                            <InputLabel>{t("LBL_OPERATOR")}</InputLabel>
                                            <Select MenuProps={{
                                                PaperProps: {
                                                    style: {
                                                        maxHeight: 200, // Adjust this value
                                                    },
                                                },
                                            }} size="small" name="COMPARE" value={selectedNode.COMPARE} onChange={handleChange}>
                                                {operatorDropdown}
                                            </Select>
                                        </FormControl>
                                    </div>
                                    {!["TRUE", "FALSE"].includes(selectedNode.COMPARE) ? <div style={{ display: "flex" }}>
                                        <FormControlLabel disabled={!selectedNode?.hasOwnProperty("key")} control={<Checkbox name="COMPARE_ACTION_IGNORECASE" checked={selectedNode.COMPARE_ACTION_IGNORECASE === "TRUE"} onChange={handleChange} />} label={t("IGNORECASE")} />
                                        <FormControlLabel disabled={!selectedNode?.hasOwnProperty("key")} control={<Checkbox name="COMPARE_ACTION_TRIM" checked={selectedNode.COMPARE_ACTION_TRIM === "TRUE"} onChange={handleChange} />} label={t("LBL_TRIM_DATA")} />
                                    </div> : ""}
                                    {
                                        !["EMPTY", "IS_NUMERIC", "IS_DATE", "TRUE", "FALSE"].includes(selectedNode.COMPARE) ? <>
                                            <Divider />
                                            <InputLabel>{t("LBL_DATA_MAPPING_")} 2</InputLabel>
                                            <FormControl disabled={!selectedNode?.hasOwnProperty("key")} fullWidth size="small">
                                                <InputLabel>{t("LBL_REC_NAME")}</InputLabel>
                                                <Select MenuProps={{
                                                    PaperProps: {
                                                        style: {
                                                            maxHeight: 180, // Adjust this value
                                                        },
                                                    },
                                                }} size="small" name="RECORD_TYPE2" value={selectedNode.RECORD_TYPE2} onChange={handleChange}>
                                                    {mapping2RecordDropdown}
                                                </Select>
                                            </FormControl>
                                            {selectedNode.RECORD_TYPE2 === "CONSTANT" ? <div style={{ display: "flex", gap: "5px" }}>
                                                <TextField disabled={!selectedNode?.hasOwnProperty("key")} fullWidth size="small" label={t("LBL_VALUE")} name="VALUE" value={selectedNode.VALUE} onChange={handleChange} />
                                                {selectedNode.COMPARE === "REGULAR_EXPRESSION" ?
                                                    <>
                                                        <Button disabled={!selectedNode?.hasOwnProperty("key")} variant="outlined" onClick={() => setOpenRegExDialog(true)}><MoreHorizOutlined /></Button>
                                                        <RegularExpressionDialog
                                                            openRegExDialog={openRegExDialog}
                                                            regExDocPath={regExDocPath}
                                                            handleRegExClose={() => setOpenRegExDialog(false)}
                                                            regExValue={(selectedNode.VALUE)}
                                                            setValue={
                                                                (val) => {
                                                                    handleChange({ target: { name: "VALUE", value: val } })
                                                                }
                                                            }
                                                        />
                                                    </>

                                                    : <></>}
                                            </div> : <></>}
                                            {
                                                selectedNode.RECORD_TYPE2 === "SYSTEM_DATA" ? <>
                                                    <FormControl disabled={!selectedNode?.hasOwnProperty("key")} fullWidth size="small">
                                                        <InputLabel>{t("LBL_MAPPING_NAME")}</InputLabel>
                                                        <Select MenuProps={{
                                                            PaperProps: {
                                                                style: {
                                                                    maxHeight: 200, // Adjust this value
                                                                },
                                                            },
                                                        }} size="small" name="MAPNAME2" value={selectedNode.MAPNAME2} onChange={handleChange}>
                                                            {systemDataDropdown}
                                                        </Select>
                                                    </FormControl>
                                                </> : <></>
                                            }
                                            {
                                                selectedNode.RECORD_TYPE2 === "ACCOUNT_KEYS" ? <>
                                                    <FormControl disabled={!selectedNode?.hasOwnProperty("key")} fullWidth size="small">
                                                        <InputLabel>{t("LBL_MAPPING_NAME")}</InputLabel>
                                                        <Select MenuProps={{
                                                            PaperProps: {
                                                                style: {
                                                                    maxHeight: 200, // Adjust this value
                                                                },
                                                            },
                                                        }} size="small" name="MAPNAME2" value={selectedNode.MAPNAME2} onChange={handleChange}>
                                                            {accountKeys}
                                                        </Select>
                                                    </FormControl>
                                                </> : <></>
                                            }
                                            {
                                                selectedNode.RECORD_TYPE2 === "TRADING_PARTNER_KEYS" ? <>
                                                    <FormControl disabled={!selectedNode?.hasOwnProperty("key")} fullWidth size="small">
                                                        <InputLabel>{t("LBL_MAPPING_NAME")}</InputLabel>
                                                        <Select MenuProps={{
                                                            PaperProps: {
                                                                style: {
                                                                    maxHeight: 200, // Adjust this value
                                                                },
                                                            },
                                                        }} size="small" name="MAPNAME2" value={selectedNode.MAPNAME2} onChange={handleChange}>
                                                            {tradingpartnerKeys}
                                                        </Select>
                                                    </FormControl>
                                                </> : <></>
                                            }
                                            {
                                                ["SEG_VAL_ERR",
                                                    "ELEM_VAL_ERR",
                                                    "TRN_SET_VAL_ERR",
                                                    "FNCT_GRP_VAL_ERR"].includes(selectedNode.RECORD_TYPE2) ? <>
                                                    <FormControl disabled={!selectedNode?.hasOwnProperty("key")} fullWidth size="small">
                                                        <InputLabel>{t("LBL_MAPPING_NAME")}</InputLabel>
                                                        <Select MenuProps={{
                                                            PaperProps: {
                                                                style: {
                                                                    maxHeight: 200, // Adjust this value
                                                                },
                                                            },
                                                        }} size="small" name="MAPNAME2" value={selectedNode.MAPNAME2} onChange={handleChange}>
                                                            {
                                                                TRANSLATE_OUTBOUND_CONDITION_MAPPING_2_SOURCE[selectedNode?.RECORD_TYPE2]?.map(e => {
                                                                    return <MenuItem value={e?.value}>{e?.title}</MenuItem>
                                                                })
                                                            }
                                                        </Select>
                                                    </FormControl>
                                                </> : <></>
                                            }
                                            {
                                                selectedNode?.RECORD_TYPE2 === "SESSION_DATA" ? <WorkflowSourceType
                                                    node={
                                                        {
                                                            key: selectedNode?.key,
                                                            RECORD_TYPE: selectedNode?.RECORD_TYPE2,
                                                            WFITEM: selectedNode?.WF_ITEM_2,
                                                            OUTBOUND_NAME: selectedNode?.OUTBOUND_2,
                                                            MAPNAME: selectedNode?.MAPNAME2
                                                        }
                                                    }
                                                    valuesHandler={(values) => {
                                                        conditionsUpdater(null, null, {
                                                            RECORD_TYPE2: values?.RECORD_TYPE,
                                                            WF_ITEM_2: values?.WFITEM,
                                                            OUTBOUND_2: values?.OUTBOUND_NAME,
                                                            MAPNAME2: values?.MAPNAME,
                                                            WF_ITEM_ID_2: values?.WF_ITEM_ID
                                                        })
                                                    }}
                                                    onlySessionData={true}

                                                /> : ""
                                            }
                                        </> : <></>
                                    }
                                </>

                        }
                    </Stack>



                </DialogContent>
                <DialogActions>
                    <Button variant="contained" onClick={handleClose}>{t("BTN_DONE")}</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}


const conditionNode = {
    "NAME": "UNNAMED",
    "COMPARE": "EQUALS",
}
const compoundConditionNode = {
    "NAME": "COMPOUND CONDITION",
    "RECORD_TYPE2": "CONSTANT",
    "CHILDOPERATOR": "AND",
    "CONDITION": [
        {
            "NAME": "UNNAMED1",
            "OPERATOR": "AND",
            "COMPARE": "EQUALS",
        },
        {
            "NAME": "UNNAMED1",
            "OPERATOR": "AND",
            "COMPARE": "EQUALS",
        }
    ]
}



export default OutboundConditionModal


const styles = {
    dialogHeader: {
        padding: "5px 10px"
    },
    dialog: {
        '& .MuiDialog-paper': {
            height: '600px'
        }
    }
}